import request from "../utils/request";

export function getData(params ={}) {
  return request({
    url: "khu-vuc",
    method: "get",
    params,
  });
}

export function show(id,params = {}) {
  return request({
    url: `khu-vuc/${id}`,
    method: "get",
    params,
  });
}

export function update(data = {}, id) {
  return request({
    url: `khu-vuc/${id}`,
    method: "post",
    data,
  });
}

export function store(data) {
  return request({
    url: "khu-vuc",
    method: "post",
    data,
  });
}

export function destroy(id) {
  return request({
    url: `khu-vuc/${id}`,
    method: "delete",
  });
}
